import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SvgIcon, SvgFill } from '@chegg-ui/svg-icon';
var SocialSkills = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement(SvgFill, {
    d: "M25.54.153C17.247-.953 9.532 4.035 7.186 12.025c-.54 1.847-.25 3.845.79 5.503.628.993.665 1.495.628 1.583l-4.316 6.307a2.256 2.256 0 0 0-.138 2.3 2.226 2.226 0 0 0 1.97 1.18h2.346v5.528c0 2.538 2.057 4.599 4.579 4.599H14.6v4.033c0 .515.427.942.941.942.515 0 .941-.427.941-.942v-4.033h2.798a6.773 6.773 0 0 0 5.833-3.367l1.518-2.614a.928.928 0 0 0-.338-1.281.925.925 0 0 0-1.28.34l-1.518 2.612a4.882 4.882 0 0 1-4.203 2.425H13.07a2.706 2.706 0 0 1-2.697-2.714v-6.47a.948.948 0 0 0-.941-.942H6.145a.34.34 0 0 1-.301-.176.329.329 0 0 1 .025-.352l4.315-6.307c.59-.867.39-2.098-.59-3.656-.752-1.193-.965-2.638-.576-3.957C11.1 5.48 17.963 1.045 25.327 2.025c6.523.867 11.73 6.03 12.658 12.55.828 5.768-.314 10.152-3.387 13.042-1.43 1.344-2.196 3.342-2.108 5.478l.427 10a.95.95 0 0 0 .94.905h.038a.958.958 0 0 0 .903-.98l-.426-10.013c-.075-1.608.464-3.04 1.505-4.02 3.488-3.292 4.855-8.368 3.952-14.687C38.763 6.962 32.892 1.145 25.54.152Z"
  }), /*#__PURE__*/React.createElement(SvgFill, {
    d: "M30.897 12.39a.946.946 0 0 0-1.33 0l-8.606 8.619-3.362-3.367a.945.945 0 0 0-1.33 0 .949.949 0 0 0 0 1.331l4.027 4.033a.93.93 0 0 0 .665.276.93.93 0 0 0 .665-.276l9.27-9.284a.927.927 0 0 0 0-1.332Z"
  }));
});
SocialSkills.displayName = 'SocialSkills';
SocialSkills.defaultProps = {
  'aria-label': 'SocialSkills'
};
export default SocialSkills;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-ui/horizon-icons/dist/esm/icons/Subject/SocialSkills.js
// module id = 3081
// module chunks = 11